import Select from 'react-select'
import React, {FC, useEffect, useState} from 'react'
import moment from 'moment-timezone'
import DatePicker from 'react-datepicker'
import ReactPaginate from 'react-paginate'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {MessageType} from '../Types'
import {MessageReportParams} from '../../../../../services/cellcast.v2.types'
import {useLoadedData} from '../../../../hooks/useGetLoadedData'
import NodataYet from '../../../../Components/NodataYet'
import {
  checkIsScheduled,
  MessageDeliveryStatus,
  SchedulerTypeOptions,
  ScheduleStatus,
  visualizeHiddenCharacters,
} from '../Common'
import {
  cellcastApi,
  useDeleteSchedulerMutation,
  useGetSchedulersQuery,
  usePauseSchedulerMutation,
} from '../../../../../services/cellcast'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import {RoutePaths} from '../../../../routing/RoutePath'
import clsx from 'clsx'
import {useDispatch} from 'react-redux'
import {toast} from 'react-toastify'
import {useLazyGetFileSchedulerMessageExportQuery} from '../../../../../services/cellcast'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const FileSchedulerMessage = () => {
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  // configure date range

  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const [deleteScheduler, {isLoading: isLoadingDeleteScheduler}] = useDeleteSchedulerMutation()
  const [pauseScheduler, {isLoading: isLoadingPauseScheduler}] = usePauseSchedulerMutation()

  const pauseSchedulerHandler = async (id: any) => {
    pauseScheduler({id})
      .unwrap()
      .then((res) => {
        toast.success('success')
        refetch()
      })
      .catch((e) => toast.error(e?.data?.message))
  }

  const deleteSchedulerHandler = async (id: any) => {
    deleteScheduler({id})
      .unwrap()
      .then((res) => {
        toast.success('success')
        refetch()
      })
      .catch((e) => toast.error(e?.data?.message))
  }

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [params, setParams] = useState<MessageReportParams>({
    fromDate: moment(sevenDaysAgo).format('YYYY-MM-DD'),
    toDate: moment(today).format('YYYY-MM-DD'),
    page: 1,
    limit: 10,
  })

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    setDateRange(dateRangeParams)
  }

  const {data, isLoading, isFetching, refetch} = useGetSchedulersQuery(params)

  const [downloadFileScheduler, {isFetching: isDownloadFetching}] =
    useLazyGetFileSchedulerMessageExportQuery()

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  const handleSetSort = (sortKey: string, sortValue: string) => {
    setParams({
      ...params,
      sortKey,
      sortValue,
    })
  }

  const handleExport = () => {
    downloadFileScheduler({...params, isExport: true})
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <div>
                <span className='card-label fw-bolder fs-2 mb-1'>All File Scheduled Messages</span>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id="tooltip-bottom">
                    <div>
                      <span>Show scheduled messages sent via uploaded File Scheduler.</span>
                    </div>
                  </Tooltip>}
                >
                  <i
                    className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                  />
                </OverlayTrigger>
              </div>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'>
              <div className='col-md-3'>
                <div className='d-flex'>
                  <DatePicker
                    selectsRange={true}
                    dateFormat='MMM d, yyyy'
                    className=' border-0 form-control form-control-lg form-control-solid'
                    placeholderText='Pick data & time'
                    onChange={(update) => {
                      setDateParams(update)
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={isLoading}
                  />
                  <span
                    className='input-group-text'
                    style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
                  >
                    <i className='bi bi-calendar'></i>
                  </span>
                </div>
              </div>
              <div className='ms-2 col-xs-4 col-md-3 '>
                <Select
                  options={SchedulerTypeOptions}
                  onChange={(e) => {
                    setParams({...params, type: e?.value})
                  }}
                  isDisabled={isLoading}
                />
              </div>
              <div className='d-flex align-items-center position-relative m-0'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-1 position-absolute ms-6'
                />
                <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid w-250px ps-14'
                  placeholder='Search number'
                  onChange={(e) => setParams({...params, receiver: e?.target?.value})}
                />
              </div>

              <div className='ms-2'>
                <button type='button' onClick={handleExport} className='btn btn-light-primary'>
                  {isDownloadFetching ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data?.items && data?.data?.items?.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-100px'>Type</th>
                        <th
                          className='p-0'
                          onClick={() => {
                            handleSetSort(
                              `nextExecution`,
                              params.sortKey === `nextExecution`
                                ? params.sortValue === 'desc'
                                  ? 'asc'
                                  : 'desc'
                                : 'asc'
                            )
                          }}
                        >
                          {params.sortKey === 'nextExecution' ? (
                            params.sortValue && params.sortValue === 'desc' ? (
                              <i className='bi bi-arrow-up-short me-2'></i>
                            ) : (
                              <i className='bi bi-arrow-down-short me-2'></i>
                            )
                          ) : (
                            <i className='bi bi-arrow-down-up me-2'></i>
                          )}
                          Next Execution
                        </th>
                        <th className='p-0 min-w-30px ps-3'>Timezone</th>
                        <th className='p-0 min-w-30px ps-3'>From Sender ID</th>
                        <th className='p-0 min-w-30px ps-3'>To Number</th>
                        <th className='p-0 min-w-60px ps-3'>Message</th>
                        <th className='p-0 min-w-60px ps-3'>Type</th>
                        <th className='p-0 min-w-60px ps-3'>Status</th>
                        <th className='p-0 min-w-30px ps-3'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((key, i) => {
                            const scheduleStatus = checkIsScheduled({
                              status: key?.status,
                              nextExecution: key?.nextExecution,
                              active: key?.active,
                              messageStatus: key?.messageStatus,
                            })

                            const badgeClass = clsx({
                              'badge badge-light-success fw-bold': [
                                MessageDeliveryStatus.DELIVERED,
                              ].includes(key?.gatewayMessageStatus),
                              'badge badge-light-danger fw-bold': [
                                ScheduleStatus.FAILED,
                                ScheduleStatus.CANCELLED,
                              ].includes(scheduleStatus),
                              'badge badge-light-warning fw-bold': [
                                ScheduleStatus.SCHEDULED,
                              ].includes(scheduleStatus),
                              'badge badge-light-info fw-bold': [
                                MessageDeliveryStatus.SEND,
                                MessageDeliveryStatus.QUEUED,
                              ].includes(key?.gatewayMessageStatus),
                            })

                            return (
                              <React.Fragment key={i}>
                                <tr className='border-dashed border-2 border-bottom'>
                                  <td className='top-align'>
                                    <div className='symbol symbol-50px me-2'>
                                      <span className='symbol-label badge green_text_badge fs-7 badge-square p-4 w-50px h-50px'>
                                        {MessageType.SMS.toString()}
                                      </span>
                                    </div>
                                  </td>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>
                                      {moment(key?.nextExecution)
                                        .tz(key?.fileSchedule?.timezone)
                                        .format('DD-MM-YYYY HH:mm:ss')}
                                    </span>
                                  </td>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>
                                      {key?.fileSchedule?.timezone}
                                    </span>
                                  </td>
                                  <td className='top-align'>{key?.sender || '-'}</td>
                                  <td className='top-align'>{key?.receiver || '-'}</td>
                                  <td className='top-align'>
                                    <div className='message-display'>
                                      {visualizeHiddenCharacters(key?.message || '-')}
                                    </div>
                                  </td>
                                  <td className='top-align'>
                                    <div className='message-display'>
                                      {key?.type?.toUpperCase()}
                                    </div>
                                  </td>
                                  <td className='top-align'>
                                    <span className={badgeClass}>
                                      {key?.gatewayMessageStatus?.toUpperCase()}
                                    </span>
                                  </td>
                                  <td className='top-align'>
                                    <div className='d-flex gap-2 justify-content-end'>
                                      {![
                                        ScheduleStatus.COMPLETED,
                                        ScheduleStatus.CANCELLED,
                                        ScheduleStatus.FAILED,
                                      ].includes(scheduleStatus) && (
                                        <>
                                          <OverlayTrigger
                                            placement='bottom'
                                            overlay={<Tooltip id='button-tooltip'>Cancel</Tooltip>}
                                          >
                                            <button
                                              className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger'
                                              onClick={() => {
                                                deleteSchedulerHandler(key?._id)
                                              }}
                                              disabled={isLoadingDeleteScheduler}
                                            >
                                              <i className='bi bi-x fs-5'></i>
                                            </button>
                                          </OverlayTrigger>
                                        </>
                                      )}

                                      <OverlayTrigger
                                        placement='bottom'
                                        overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
                                      >
                                        <Link
                                          to={RoutePaths.schedulerDetail.replace(':id', key?._id)}
                                          className='btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/arrows/arr064.svg'
                                            className='svg-icon-2'
                                          />
                                        </Link>
                                      </OverlayTrigger>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            )
                          })}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                    }}
                    // value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } data`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No recent file scheduler sms messages (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default FileSchedulerMessage
